import { Reveal, SectionTag } from "./Reveal";

const chapters = [
  {
    n: "01",
    title: "Zero Blind-Spot Blueprint",
    desc: "Every job starts with a site walkthrough. Camera angles, heights and sight-lines are mapped before a single hole is drilled — so no corner of your property goes unwatched.",
  },
  {
    n: "02",
    title: "Stealth Cable Management",
    desc: "Tamper-proof conduit routing, hidden wiring and weather-sealed joints. Clean walls outside, clean signals inside.",
  },
  {
    n: "03",
    title: "Watch From Anywhere",
    desc: "NVR + mobile streaming configured on your phone before we leave. Live view, playback and alerts — from Ghaziabad or Goa.",
  },
  {
    n: "04",
    title: "We Come Back. That's the Point.",
    desc: "1-year on-site warranty with 3 free services for the year. 70 five-star Google reviews exist because we answer the phone after the invoice too.",
  },
];

export default function Manifesto() {
  return (
    <section className="relative py-28 sm:py-36 bg-alt border-y border-line noise" data-testid="manifesto-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <SectionTag index="02" label="The Security Codex" />
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight max-w-2xl">
            How every installation <span className="text-cyan-400">is done right.</span>
          </h2>
        </Reveal>

        <div className="mt-16 space-y-0">
          {chapters.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.06}>
              <div
                className="group grid grid-cols-12 gap-4 sm:gap-8 items-baseline py-10 border-t border-line last:border-b transition-colors duration-500 hover-wash"
                data-testid={`manifesto-chapter-${c.n}`}
              >
                <span className="col-span-3 sm:col-span-2 font-display font-extrabold text-4xl sm:text-6xl text-stroke transition-all duration-500 group-hover:text-cyan-400 group-hover:[-webkit-text-stroke:0px]">
                  {c.n}
                </span>
                <h3 className="col-span-9 sm:col-span-4 font-display text-xl sm:text-2xl font-semibold text-strong">
                  {c.title}
                </h3>
                <p className="col-span-12 sm:col-span-6 text-sm sm:text-base text-soft leading-relaxed">
                  {c.desc}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
